<template>
  <div class="enter-community-container">
    <el-card v-if="showPage === 'myCommunity'">
      <div slot="header" class=" flex justify-between">
        <span>{{ $t('enterCommunity.myCommunity') }}</span>
        <el-button type="primary" size="small"  @click="showHcUse">
          <i class="el-icon-plus"></i>
          {{ $t('enterCommunity.commercialProcess') }}
        </el-button>
      </div>

      <el-table :data="communityList" border v-loading="loading">
        <el-table-column prop="provName" :label="$t('enterCommunity.province')" align="center" />
        <el-table-column prop="cityName" :label="$t('enterCommunity.city')" align="center" />
        <el-table-column prop="areaName" :label="$t('enterCommunity.district')" align="center" width="150" />
        <el-table-column prop="name" :label="$t('enterCommunity.communityName')" align="center" width="200" />
        <el-table-column prop="communityId" :label="$t('enterCommunity.communityCode')" align="center" />
        <el-table-column prop="tel" :label="$t('enterCommunity.servicePhone')" align="center" />
        <el-table-column prop="communityArea" :label="$t('enterCommunity.area')" align="center" />
        <el-table-column prop="startTime" :label="$t('enterCommunity.startTime')" align="center" />
        <el-table-column prop="endTime" :label="$t('enterCommunity.endTime')" align="center" />
        <el-table-column :label="$t('enterCommunity.status')" align="center">
          <template slot-scope="{ row }">
            {{ statusMap[row.auditStatusCd] || row.auditStatusCd }}
          </template>
        </el-table-column>
        <!-- 修改：操作列宽度从120改为200，增加公章按钮  create by cht at 2026/6/18 15:00 -->
        <el-table-column :label="$t('enterCommunity.operation')" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button v-if="row.auditStatusCd === '1100'" type="text" size="small" @click="openEditDialog(row)">
              {{ $t('enterCommunity.modify') }}
            </el-button>
            <!-- 新增：公章按钮，有公章显示"查看公章"，无公章显示"上传公章" create by cht at 2026/6/18 15:00 -->
            <el-button type="text" size="small" @click="handleSeal(row)">
              {{ getSealAttr(row) ? $t('enterCommunity.viewSeal') : $t('enterCommunity.uploadSeal') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="pagination" :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.size" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange" @current-change="handlePageChange" />
    </el-card>

    <el-card v-else>
      <div slot="header" class=" flex justify-between">
        <div>{{ $t('enterCommunity.commercialProcess') }}</div>
        <el-button type="primary" size="small"  @click="goBack">
          <i class="el-icon-close"></i>
          {{ $t('enterCommunity.back') }}
        </el-button>
      </div>

      <div class="commercial-content">
        <img src="/img/hc_use.png" alt="Commercial Process">
      </div>
    </el-card>

    <edit-community-area ref="editDialog" @success="fetchCommunityList" />

    <!-- 新增：公章弹窗(上传/查看共用)  create by cht at 2026/6/18 15:00 -->
    <el-dialog :title="sealDialogTitle" :visible.sync="sealVisible" width="500px">
      <div style="text-align: center; padding: 20px;">
        <!-- 无公章：显示上传组件 -->
        <div v-if="!currentSealUrl">
          <upload-image-url ref="uploadImage" :limit="1" @notifyUploadCoverImage="handleSealUpdate" />
        </div>

        <!-- 有公章：显示图片，右上角×删除 -->
        <div v-else class="seal-preview">
          <img :src="currentSealUrl" class="seal-image">
          <i class="el-icon-close seal-delete" @click="deleteSeal"></i>
        </div>
      </div>

      <div slot="footer">
        <el-button @click="sealVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="saveSeal" :loading="saving">{{ $t('common.save') }}</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
// 修改：引入 updateCommunity 接口 create by cht at 2026/6/18 15:00
import { listMyCommunity,updateCommunity } from '@/api/community/enterCommunityApi'
import EditCommunityArea from '@/components/community/editCommunityArea.vue'
// 新增：引入 UploadImageUrl 组件
import UploadImageUrl from '@/components/upload/UploadImageUrl.vue'


export default {
  name: 'EnterCommunityList',
  components: { EditCommunityArea,UploadImageUrl},  // 新增UploadImageUrl  create by cht at 2026/6/18 16:05
  data() {
    return {
      showPage: 'myCommunity',
      loading: false,
      communityList: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      statusMap: {
        '1000': this.$t('enterCommunity.statusOptions.1000'),
        '1100': this.$t('enterCommunity.statusOptions.1100'),
        '1200': this.$t('enterCommunity.statusOptions.1200')
      },
      // 新增：公章弹窗相关数据  create by cht at 2026/6/18 15:40
      sealVisible: false,
      sealDialogTitle: '',
      currentSealUrl: '',
      currentSealAttrId: '',   // 保存当前公章的 attrId
      currentRow: null,
      saving: false
    }
  },
  mounted() {
    this.fetchCommunityList()
  },
  methods: {
    async fetchCommunityList() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          communityId: this.getCommunityId()
        }
        const data = await listMyCommunity(params)
        this.communityList = data
        this.pagination.total = data.length
      } catch (error) {
        this.$message.error(error.message || this.$t('enterCommunity.fetchError'))
      } finally {
        this.loading = false
      }
    },
    // 新增:从 communityAttrDtos 中解析公章属性  create by cht at 2026/6/18 15:40
    getSealAttr(row) {
      if (!row.communityAttrDtos || !Array.isArray(row.communityAttrDtos)) {
        return null
      }
      return row.communityAttrDtos.find(attr => attr.specCd === '1005320999')
    },
    openEditDialog(community) {
      this.$refs.editDialog.open(community)
    },
    /*============================== 新增公章相关方法 create by cht at 2026/6/18 15:05 ====================================*/
    // 新增：公章按钮点击事件
    handleSeal(row) {
      this.currentRow = row
      const sealAttr = this.getSealAttr(row)
      if (sealAttr) {
        // 有公章
        this.currentSealUrl = sealAttr.value
        this.currentSealAttrId = sealAttr.attrId
        this.sealDialogTitle = this.$t('enterCommunity.viewSeal')
      } else {
        // 无公章
        this.currentSealUrl = ''
        this.currentSealAttrId = ''
        this.sealDialogTitle = this.$t('enterCommunity.uploadSeal')
      }
      this.sealVisible = true

      // 新增：等弹窗完全打开后再初始化上传组件
      setTimeout(() => {
        if (this.$refs.uploadImage) {
          if (this.currentSealUrl) {
            this.$refs.uploadImage.setImages([this.currentSealUrl])
          } else {
            this.$refs.uploadImage.setImages([])
          }
        }
      }, 500)  // 给弹窗动画时间
    },
    // 新增：公章上传成功回调
    handleSealUpdate(photosUrl) {
      this.currentSealUrl = photosUrl.length > 0 ? photosUrl[0] : ''
    },
    // 新增：删除公章
    deleteSeal() {
      this.$confirm(this.$t('enterCommunity.confirmDeleteSeal'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        // 有 attrId 说明数据库已有记录，需要更新状态为无效
        if (this.currentSealAttrId) {
          try {
            this.saving = true
            await updateCommunity({
              communityId: this.currentRow.communityId,
              name: this.currentRow.name,
              address: this.currentRow.address,
              nearbyLandmarks: this.currentRow.nearbyLandmarks,
              attrs: [{
                attrId: this.currentSealAttrId,
                specCd: '1005320999',
                statusCd: '1'  // 状态改为无效
              }]
            })
            this.$message.success(this.$t('common.deleteSuccess'))
            this.sealVisible = false
            this.fetchCommunityList()
          } catch (error) {
            this.$message.error(error.message || this.$t('common.deleteError'))
          } finally {
            this.saving = false
          }
        } else {
          // 没有 attrId，只是本地预览，直接清空
          this.currentSealUrl = ''
          if (this.$refs.uploadImage) {
            this.$refs.uploadImage.setImages([])
          }
          // 可选：切换回上传状态
          this.sealDialogTitle = this.$t('enterCommunity.uploadSeal')
        }
      })
    },
    // 新增：保存公章
    async saveSeal() {
      try {
        this.saving = true
        // 构建 attrs 数组
        const attrs = []
        if (this.currentSealUrl) {
          const attr = {
            specCd: '1005320999',      // 公章属性编码
            value: this.currentSealUrl, // 公章图片URL
            // specName: '小区公章'
          }
          // 有 attrId 说明是更新，没有是新增
          if (this.currentSealAttrId) {
            attr.attrId = this.currentSealAttrId
          }
          attrs.push(attr)
        }
        await updateCommunity({
          communityId: this.currentRow.communityId,
          name: this.currentRow.name,
          address: this.currentRow.address,
          nearbyLandmarks: this.currentRow.nearbyLandmarks,
          attrs: attrs
        })
        this.$message.success(this.$t('common.saveSuccess'))
        this.sealVisible = false
        this.fetchCommunityList()
      } catch (error) {
        this.$message.error(error.message || this.$t('common.saveError'))
      } finally {
        this.saving = false
      }
    },
    /*============================== 新增公章 create by cht at 2026/6/18 15:05 ====================================*/
    showHcUse() {
      this.showPage = 'hcUse'
    },
    goBack() {
      this.showPage = 'myCommunity'
    },
    handlePageChange(page) {
      this.pagination.current = page
      this.fetchCommunityList()
    },
    handleSizeChange(size) {
      this.pagination.size = size
      this.fetchCommunityList()
    }
  }
}
</script>

<style scoped>
.enter-community-container {
  padding: 20px;
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

.float-right {
  float: right;
}

.commercial-content {
  text-align: center;
  padding: 20px 0;
}

.commercial-content img {
  max-width: 100%;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

/*================== 新增:公章弹窗样式   create by cht at 2026/6/18 15:05 =============== */
.seal-preview {
  position: relative;
  display: inline-block;
}
.seal-image {
  width: 200px;
  height: 200px;
  object-fit: cover;
  border-radius: 6px;
}
.seal-delete {
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 20px;
  color: #f56c6c;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  padding: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
}
/*================== 新增:公章弹窗样式   create by cht at 2026/6/18 15:05 =============== */
</style>
